export default class LanguageEvent {
    constructor(type) {
        this.type = type;
    }
}

LanguageEvent.INITIALIZED = "LanguageEvent.INITIALIZED";